export const DEFAULT_AVAILABLE_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
export const DEFAULT_INTERVAL = { from: '09:00', to: '17:00' }
export const CUSTOM_RULE_ID = '_custom_rule'
